export default "__VITE_ASSET__Cs4B577h__"